<template>
  <div class="user-guide-wraper">
    <!-- 引导弹窗 -->
    <div v-for="items in data" :key="items.id">
      <div v-if="bootSteps === items.id" :class="items.class">
        <div :class="['user-guide-mask', 'user-guide-mask-' + items.type]" :style="subtractHeight ? { top: '34px', left: '60px' } : null" v-if="items.needMask">
          <template v-if="items.type === 'default'">
            <div
              class="user-guide-top"
              :style="{
                height: (items.highlightArea.top + isMsgTop) + 'px'
              }"></div>
            <div
              class="user-guide-left"
              :style="{
                top: items.highlightArea.top + isMsgTop + 'px',
                width: items.highlightArea.left + 'px',
                height: items.highlightArea.height + 'px'
              }"></div>
            <div
              class="user-guide-right"
              :style="{
                top: items.highlightArea.top + isMsgTop + 'px',
                left: items.highlightArea.left + items.highlightArea.width + 'px',
                height: items.highlightArea.height + 'px'
              }"></div>
            <div
              class="user-guide-bottom"
              :style="{
                top: items.highlightArea.top + isMsgTop + items.highlightArea.height + 'px'
              }"></div>
          </template>
        </div>
        <div
          class="user-guide-content"
          :style="items.type === 'modal' ? {
            top: '50%',
            left: (clientWidth + items.modalArea.width + items.guideWidth + addWidth) / 2 + 'px',
          } : {
            top: items.guideArea.top + (items.type === 'modal' ? 0 : isMsgTop) + 'px',
            left: items.guideArea.left + 'px',
          }">
          <div class="user-guide-main flex justify-between">
            <div v-if="items.content">{{ items.content }}</div>
            <i class="el-icon-close size16 gj-ml8 gj-pointer" @click="setUserGuideState" style="color: rgba(255, 255, 255, 0.4)"></i>
          </div>
          <div class="flex justify-between align-center gj-mt12">
            <div>{{bootSteps}}/{{data.length}}</div>
            <div v-if="items.btnList.length" class="btnList">
              <div v-if="items.btnList.includes('video')" class="gj-pointer">
                <gj-link style="color:#fff;" type="text" :href="getVideoUrl(taskItem.videoUrlCode)" target="_blank">参考教程 </gj-link><i class="el-icon-arrow-right"></i>
              </div>
              <div v-if="items.btnList.includes('know')" @click="nextTask" class="gj-pointer knowBtn">我知道了</div>
              <div v-if="items.btnList.includes('complete')" @click="nextTask" class="gj-pointer completeBtn">完成任务</div>
            </div>
          </div>
          <div class="user-guide-point" :style="{ width: items.guideWidth + 'px', left: `-${items.guideWidth}px` }">
            <div class="user-guider-line"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SET_USER_GUIDE_STATE, SET_USER_GUIDE_MENU_PATH, SET_USER_GUIDE_TASK_ITEM} from "@/store/mutation-types";
import appUserGuideSucc from "@/views/components/user-guide-succ-modal/user-guide-succ-modal"
import {userGuideMixin} from "@/minxins";
import {mapGetters} from "vuex";
export default {
  name: "new-user-guide",
  mixins: [userGuideMixin],
  props: {
    guideRef: {
      value: null
    }
  },
  data() {
    return {
      bootSteps: 0,
      startStep: 'SHOP_MANAGE_001',
      data: [],
      taskName: '',
      taskList: {},
      isMsgTop: 0,
      clientWidth: 0,
      clientHeight: 0,
      subtractHeight: 0,
      addWidth: 0,
      taskItem: null
    }
  },
  computed: {
    ...mapGetters({
      isMsgsGlobal: 'isMsgsGlobal',
      userGuideState: 'userGuideState',
    })
  },
  watch: {
    isMsgsGlobal: {
      handler(val) {
        this.isMsgTop = val ? 34 : 0;
      },
      immediate: true
    },
    userGuideState: {
      handler(newState, oldState) {
        if(!newState && oldState) this.cancel();
      }
    }
  },
  created() {
    this.clientWidth = document.body.clientWidth;
    this.clientHeight = document.body.clientHeight;
    this.initData();
    this.bootSteps = 1;
    this.taskItem = this.userGuideTaskItem;
    this.startStep = this.taskItem.taskChildCode;
    this.data = this.taskList[this.startStep];
    this.taskName = this.startStep;
  },
  methods: {
    initData(){
      const isNavHorizontal = localStorage.getItem('NAV_STATE') !== 'vertical'
      const subtractHeight =  isNavHorizontal ? 0 : 40;
      const addWidth =  isNavHorizontal ? 0 : 60;
      this.subtractHeight = subtractHeight;
      this.addWidth = addWidth;
      this.taskList = {
        SHOP_MANAGE_001: [
          {
            id: 1,
            class: "user-guide-one",
            type: 'default',
            needMask: true,
            highlightArea: {
              width: 84,
              height: 34,
              top: 147 - subtractHeight,
              left: 30 + addWidth,
            },
            guideArea: {
              top: 130 - subtractHeight,
              left: 168 + addWidth,
            },
            guideWidth: 60,
            content: "点击【店铺授权】按钮，开始进行授权吧~",
            btnList: [],
          },
          {
            id: 2,
            class: "user-guide-two",
            type: 'modal',
            needMask: false,
            modalArea: {
              width: 680
            },
            guideWidth: 60,
            guideRef: null,
            content: "将店铺授权给系统，让系统可以通过亚马逊的API接口获取店铺销售数据，方便您在系统管理您的店铺",
            btnList: ['video'],
          },
          {
            id: 3,
            class: "user-guide-three",
            type: 'menu',
            path: '/sale/listing',
            needMask: true,
            guideArea: {
              top: 120,
              left: isNavHorizontal ? 965 : 240,
            },
            guideWidth: 60,
            content: "您的店铺授权已经成功啦~系统已经开始为您进行初始化数据同步了，稍后您可以在这里查看和管理您的listing、销售订单等数据，也可以查看系统为您生成的报表与分析看板哦~",
            btnList: ['know'],
          }
        ],
        SHOP_MANAGE_002: [
          {
            id: 1,
            class: "user-guide-one",
            type: 'default',
            needMask: true,
            highlightArea: {
              width: 120,
              height: 700,
              top: 196 - subtractHeight,
              left: 1100 + addWidth,
            },
            guideArea: {
              top: 274 - subtractHeight,
              left: 1250 + addWidth,
            },
            guideWidth: 60,
            content: "点击【待授权】，继续完成广告授权任务吧~",
            btnList: [],
          },
          {
            id: 2,
            class: "user-guide-two",
            type: 'modal',
            needMask: false,
            modalArea: {
              width: 680
            },
            guideWidth: 60,
            content: "将店铺的广告授权给系统，让系统可以通过亚马逊的API接口获取店铺的广告数据，方便您在系统管理您投放的广告",
            btnList: ['video'],
          },
          {
            id: 3,
            class: "user-guide-three",
            type: 'menu',
            path: '/ad/sp-ad',
            needMask: true,
            guideArea: {
              top: 108,
              left: isNavHorizontal ? 795 : 240,
            },
            guideWidth: 40,
            content: "您的广告授权已经成功啦~系统已经开始为您进行初始化数据同步了，稍后您可以在这里查看和管理您的广告数据，也可以查看系统为您生成的广告分析报表哦~",
            btnList: ['know'],
          }
        ],
        SHOP_MANAGE_003: [
          {
            id: 1,
            class: "user-guide-one",
            type: 'default',
            needMask: true,
            highlightArea: {
              width: 120,
              height: 700,
              top: 196 - subtractHeight,
              left: 830 + addWidth,
            },
            guideArea: {
              top: 274 - subtractHeight,
              left: 980 + addWidth,
            },
            guideWidth: 60,
            content: "点击【绑定邮箱】，继续完成邮箱授权任务吧~",
            btnList: [],
          },
          {
            id: 2,
            class: "user-guide-two",
            type: 'modal',
            needMask: false,
            modalArea: {
              width: 680
            },
            guideWidth: 60,
            guideRef: null,
            content: "将店铺的售后邮箱授权给系统，让系统可以为您同步亚马逊的买家消息，同时，您也可以在系统回复买家消息哦~",
            btnList: ['video'],
          },
          {
            id: 3,
            class: "user-guide-three",
            type: 'menu',
            path: '/crm/mail-reply-manager',
            needMask: true,
            guideArea: {
              top: 116,
              left: isNavHorizontal ? 960 : 240,
            },
            guideWidth: 60,
            content: "您的邮箱授权已经成功啦~系统已经开始为您进行初始化数据同步了，稍后您可以在这里查看和回复买家消息，针对差评Review和差评Feedback，系统也会自动为您生成跟进任务哦~",
            btnList: ['complete'],
          }
        ],
      }
    },
    prevStep() {
      this.bootSteps--;
    },
    nextStep() {
      this.bootSteps++;
      let activeItem = this.data.find(item => item.id === this.bootSteps);
      if(activeItem && activeItem.type === 'menu') {
        this.$store.commit(SET_USER_GUIDE_MENU_PATH, activeItem.path);
      }
    },
    async nextTask() { // 下个任务
      const taskItem = this.taskItem;
      const { finishTaskList, nextTask } = await this.getNextTask(taskItem?.taskTypeCode, taskItem?.taskChildCode);
      let step = 1
      if(this.startStep === 'SHOP_MANAGE_001') { // 后面的小任务跳过步骤1
        step = 2
      }
      if(!finishTaskList && nextTask) { // 大任务未完成, 且有正常任务链路
        if(step == 1) this.$emit('closeModal')
        const taskChildCode = nextTask?.taskChildCode;
        this.realNextTask(step, taskChildCode, nextTask)
        if (nextTask.taskStatus !== 'COMPLETED'){ // 扭转状态
          this.changeTaskStatus(taskChildCode);
        }
      } else if(finishTaskList) { // 任务全部完成
        if(taskItem.taskStatus != 'COMPLETED') {
          this.completeTask();
        } else if(nextTask) {
          const taskChildCode = nextTask?.taskChildCode;
          if(step == 1) this.$emit('closeModal')
          this.realNextTask(step, taskChildCode, nextTask);
        } else if(!nextTask) {
          this.cancel();
        }
      }
    },

    realNextTask(bootSteps, taskChildCode, nextTask) {
      this.bootSteps = bootSteps;
      this.data = this.taskList[taskChildCode];
      this.taskItem = nextTask;
      this.taskName = taskChildCode;
      this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
      this.$store.commit(SET_USER_GUIDE_TASK_ITEM, nextTask);
    },
    // 完成大任务弹框
    completeTask() {
      this.bootSteps = 0;
      this.data = [];
      this.$emit('closeModal');
      this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
      this.$gjCreate(appUserGuideSucc,{
        global: true,
        props: {
          id: this.taskItem?.taskTypeCode
        }
      })
    },
    setUserGuideState() {
      this.$store.commit(SET_USER_GUIDE_STATE, false);
    },
    cancel() {
      //关闭引导
      this.bootSteps = 0;
      this.$emit('closeModal')
      this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
    },
  }
}
</script>
<style lang="scss" scoped>
.user-guide-mask {
  .user-guide-top, .user-guide-left, .user-guide-right, .user-guide-bottom {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 2000;
    background: rgba(0, 0, 0, 0.4);
  }
}
.user-guide-mask-menu {
  position: absolute;
  top: 75px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 2100;
  background: rgba(0, 0, 0, 0.4);
}

.user-guide-content {
  font-family: PingFang SC;
  font-style: normal;
  padding: 12px 16px;
  background: #4994FC;
  box-sizing: border-box;
  border-radius: 4px;
  width: 402px;
  font-size: 12px;
  color: #fff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.24);
  position: relative;
  position: absolute;
  z-index: 2200;
  .user-guide-point {
    width: 40px;
    position: absolute;
    left: -40px;
    top: 48%;
    .user-guider-line {
      width: 100%;
      height: 2px;
      background: #4994FC;
      &::before { // 小圆点在这里
        content: '';
        border: 1px solid #4994FC;
        background-color: #4994FC;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        margin-top: -4px;
      }
    }
  }
}
.knowBtn {
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    opacity: 0.8;
  }
}
.completeBtn {
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  background: #FFFFFF;
  color: #4994FC;
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    opacity: 0.8;
  }
}
</style>